import { SelectOption } from '@shared/components/data-table/models/SelectOption.model';

export const PAGINATION_DEFAULTS = { PAGE_INDEX: 0, PAGE_SIZE: 25 };

export const MONTHS: SelectOption[] = Array.from({ length: 12 }, (_, k) => {
  return { id: k + 1, name: 'common.months.' + (k + 1) };
});

export const MONTHS_ALL: SelectOption = { id: -1, name: 'common.all' };

export const BASE_YEAR = 2010;

export const ID_NEW = '00000000-0000-0000-0000-000000000000';

export const CONFIGURATION_TYPE = {
  ZERO_HOUR_LOAD: 1,
  PROFILE_VALUE_INTERVAL: 2,
  PROFILE_VALUE_DIFF_MAX: 3,
  PROFILE_VALUE_DIFF_MIN: 4,
};

export function getUnitByType(type: number): string {
  return type === CONFIGURATION_TYPE.PROFILE_VALUE_INTERVAL ? 'Min' : '%';
}
